module.exports = __webpack_public_path__ + "img/Efdot-bg-desktop.4bd4dc51.jpg";